import React from 'react';
import { clinic } from '../../data/clinic';
interface LogoProps {
  className?: string;
}
export function Logo({
  className = 'h-11'
}: LogoProps) {
  return <img src={clinic.logo} alt="Excellent Care Clinics" className={`${className} w-auto`} data-id="element-268" data-mp="y8tgyq1cp5w0" />;
}